import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Grid from "@material-ui/core/Grid";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { CartSummary } from "@common/cart/CartSummary";
import { ROUTES } from "@constants";
import { useGetCart } from "@hooks/useGetCart";
import { ICart } from "@features/cart/ICart";
import "@features/summary/css/summaryPage.scss";
import { Payment } from "@features/summary/Payment";
import { SummaryCustomerDetails } from "@features/customerDetails/SummaryCustomerDetails";
import { useHistory } from "react-router-dom";
import { fixUrlLanguage } from "@utils/changeLanguage";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const SummaryPage = () => {
    const { push } = useHistory();
    const isAuthenticated = keycloakUtils.isAuthenticated();

    const checkCart = (cart?: ICart) => {
        const hasCartOffers = cart?.offers?.length;

        if (!hasCartOffers) {
            push(fixUrlLanguage(ROUTES.HOME_PAGE_URL_EN));
        }
    };
    const { userCart, getCart, userCartState } = useGetCart(checkCart);

    return (
        <div className="container-boxed">
            <Grid container direction="column" spacing={7}>
                <Grid item>
                    <Card elevation={2}>
                        <HandleErrorAndLoading
                            error={userCartState.error}
                            isLoading={userCartState.isLoading}
                            retryFetch={getCart}
                        >
                            <CartSummary editable userCart={userCart} />
                        </HandleErrorAndLoading>
                    </Card>
                </Grid>
                <Grid item>
                    <Card elevation={2}>
                        <CardContent className="summary-customer__card">
                            <SummaryCustomerDetails />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item>
                    <Payment isCrossSell={isAuthenticated} />
                </Grid>
            </Grid>
        </div>
    );
};
